import React, { useEffect } from 'react';
import {
    changeNameAll,
    changeAddressAll,
    changeAddress2All,
    changeCityAll,
    changeStateAll,
    changeZipAll,
    changeColorAll,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP3T1 = React.memo((props) => {
    useEffect(() => {
        changeNameAll(props.name);
    }, [props.name]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeAddress2All(props.address2);
    }, [props.address2]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateAll(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeColorAll(props.color);
    }, [props.color]);

    let colorLi = <li>Color</li>;
    let paperLi = <li>#80 Avalanche Smooth Text</li>;
    if (parseInt(props.color) === 2) {
        colorLi = <li>Black/White</li>;
        paperLi = <li>#60 Accent Smooth Text</li>;
    }

    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Color"
                value={props.color}
                setFunction={props.setColor}
                options={[
                    { value: '1', label: 'Full Color' },
                    { value: '2', label: 'Black and White' },
                ]}
            />
            <TextField
                required
                label="Name"
                // limit={45}
                value={props.name}
                setFunction={props.setName}
                placeholder="Clinic Name or Specialty"
            />
            <hr />
            <TextField
                required
                label="Address 1"
                // limit={45}
                value={props.address}
                setFunction={props.setAddress}
                placeholder="Address Line 1"
            />
            <TextField
                label="Address 2"
                // limit={45}
                value={props.address2}
                setFunction={props.setAddress2}
                placeholder="Address Line 2"
            />
            <TextField
                required
                label="City"
                // limit={20}
                value={props.city}
                setFunction={props.setCity}
            />
            <TextField
                required
                label="State"
                // limit={20}
                value={props.state}
                setFunction={props.setState}
            />
            <TextField
                required
                label="Zip"
                // limit={10}
                value={props.zip}
                setFunction={props.setZip}
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UTHealth and UT Physicians #10 Envelope</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Variables one side</li>
                        <li>Size 9.5 wide x 4.125 tall</li>
                        <li>One side</li>
                        {colorLi}
                        {paperLi}
                    </ul>
                </div>
            </div>
        </form>
    );
});

FormP3T1.propTypes = {

}

export default FormP3T1;
